import { Button, Frame, FrameTitle, SubTitle, Title, VerisureIcon } from '../Components';

const HowToPlay = ({ setScreen, game, setGame }) => {
    return (
        <div className="w-full h-full flex justify-center items-center">
            <Frame>
                <div
                    className="bg-white bg-opacity-10 rounded-xl px-8 flex items-center justify-center text-center flex-col py-4 lg:py-12 xl:py-24"
                >
                    <FrameTitle>
                        CAM 1
                    </FrameTitle>

                    <Title>Get Ready</Title>
                    <SubTitle>How to play</SubTitle>

                    <div className="flex items-start lg:w-4/5 mt-2 lg:mt-10 xl:mt-20 gap-3 lg:gap-6">
                        <div className="w-1/2 bg-white bg-opacity-10 rounded-xl text-xs lg:text-xl rubrik-regular text-left p-3 lg:p-6">
                            <p className="text-app-yellow">How to play</p>
                            <ul className="list-disc ml-4">
                                <li>Can you identify all the everyday security risks in 30 seconds</li>
                                <li>Click on the risk when you see it</li>
                                <li>Time is deducted for incorrect clicks</li>
                            </ul>
                        </div>

                        <div className="w-1/2 rubrik-regular text-left">
                            <p className="text-app-yellow text-xs lg:text-xl">SELECT YOUR VERISURE PACKAGE</p>

                            <div className="flex gap-10 mt-4">
                                <VerisureIcon
                                    icon="building.png"
                                    active={game === 'flats'}
                                    onClick={() => setGame('flats')}
                                    title={(<>Essentials <br />for flats</>)}
                                />
                                <VerisureIcon
                                    icon="home.png"
                                    active={game === 'houses'}
                                    onClick={() => setGame('houses')}
                                    title={(<>Essentials <br />for houses</>)}
                                />
                            </div>
                        </div>
                    </div>

                    <Button
                        onClick={() => setScreen('game')}
                        className="mt-4 lg:mt-10"
                        size="small"
                    >
                        Play Now
                    </Button>
                </div>
            </Frame>
        </div>
    );
};

export default HowToPlay;
